module.exports = __webpack_public_path__ + "static/media/map.b0df3dcb.png";